import GreetingCard from "./GreetingCard";
export default GreetingCard;
